import { RootState } from "../store/community-finder-redux-store";

export const selectIsMobile = (state: RootState) => state?.appStatus?.isMobile;
